const loc = {};
const nativeLocation = require('./locationUtils');
import permission from "./permissions"


function playServiceEnabled(){
  return new Promise(function(resolve,reject){
    var success = function(response) {
      // response.isGooglePlayServicesAvailable is a boolean value
      resolve(response.isGooglePlayServicesAvailable)
    } 

    var failure = function(response) {
      resolve(false)
    }

    
    try{ GooglePlayServicesCheck.check(success, failure); }catch(e){ resolve(false) }
  })
}


loc.get = function () {
  return new Promise((async (resolve, reject) => {
    console.log('device', device);

    // Check Env
    if (device.platform != 'browser' ) {

      
      var loc = {};

      var playService = true

      if(device.platform.toLowerCase() == "android" && parseInt( device.version, 10 ) <= 6) {
        playService =  await playServiceEnabled() 
        console.log("Play service is "+playService);
      }
       

      if (device.platform.toLowerCase() == 'android' && !playService )
      {

        

          console.log("Getting using api")
        
          fetch('https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyD7I-CM6G3BPSZG_jp6YJA6ctpB2Ie5844', {
            method: 'post',
          })
          .then((response) => response.json())
          .then(function (pos) {
            console.log("Got Loc " )
            console.log(JSON.stringify(pos) )
            
      
            resolve(JSON.parse(JSON.stringify({
              coords: {
                latitude: pos.location.lat,
                longitude: pos.location.lng,
                accuracy: pos.accuracy,
              }
            })))
      
           })
           .catch(function(err) {
             console.log(JSON.stringify(err))
             reject(err)
           })
    

      }
      else {
        try{
          var enabled = await permission.location.authorized() && await permission.location.enabled()
        }catch(e){
          var enabled = false
        }
    
        if(!enabled){
          try{
            await permission.location.request()
          }catch(e){
            reject(new Error("Please give location permission"))
          }
        }


        try {
          loc = await nativeLocation.get();
          resolve(loc);
        } catch (e) {
          reject(e);
        }


      }


         
    
        
       
    } else if (device.platform == 'browser') {
      // First get via navigator

      var loc = {};
      try {
        loc = await nativeLocation.get();
        resolve(JSON.parse(loc));
      } catch (e) {
        reject(e);
      }
    }
  }));
};


export default loc;
